// import SectionContainer from "components/SectionContainer";
import useWindowPositionTop from "hooks/useWindowPositionTop";
// const NotFoundPage = () => {
//     useWindowPositionTop();
//     return (
//         <main className='main page'>
//             <SectionContainer id={'not-found"'} container={'flex column col-center gap1'}>
//                 <h1 className="not-found__title">Ошибка 404</h1>
//                 <p className="not-found__subtitle">Страница не найдена.</p>
//             </SectionContainer>
//         </main>
//     )
// }

// export default NotFoundPage;


const NotFoundPage: React.FC = () => {
    useWindowPositionTop();
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f7f8fa',
            textAlign: 'center',
            padding: '20px',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
        }}>
            <h1 style={{
                fontSize: '8rem',
                margin: 0,
                color: '#ff6b6b'
            }}>404</h1>
            <p style={{
                fontSize: '1.5rem',
                margin: '16px 0',
                color: '#333'
            }}>Страница не найдена</p>
            <a
                href="/"
                style={{
                    fontSize: '1rem',
                    color: '#1e90ff',
                    textDecoration: 'none',
                    border: '2px solid #1e90ff',
                    padding: '10px 20px',
                    borderRadius: '5px',
                    transition: 'background-color 0.3s ease, color 0.3s ease',
                    cursor: 'pointer'
                }}
                onMouseEnter={e => {
                    (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#1e90ff';
                    (e.currentTarget as HTMLAnchorElement).style.color = 'white';
                }}
                onMouseLeave={e => {
                    (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'transparent';
                    (e.currentTarget as HTMLAnchorElement).style.color = '#1e90ff';
                }}
            >
                Вернуться на главную
            </a>
        </div>
    );
};

export default NotFoundPage;
